module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-easel-fill-446619ae.svg";